import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import { PINProductRBAC } from '../pages/PinProduct/rbac'
import { DynamicChannelRBAC } from '../pages/DynamicChannel/rbac'
import { HomepageSlottingRBAC } from '../pages/HomepageSlotting/rbac'
import { infiniteScrollTabbingRolesRBAC } from '../pages/InfiniteScrollTab/rbac'
import { OnboardingMediaRBAC } from '../pages/OnboardingMedia/rbac'

const HomepageSlotting = lazy(() => import('../pages/HomepageSlotting'))
const DynamicChannel = lazy(() => import('../pages/DynamicChannel'))
const PinProductPage = lazy(() => import('../pages/PinProduct'))
const InfiniteScrollTabPage = lazy(() => import('../pages/InfiniteScrollTab'))
const OnboardingMediaPage = lazy(() => import('../pages/OnboardingMedia'))

export type PinProductNamedRoutesType =
  | 'PinProductRouter'
  | 'InfiniteScrollTabRouter'
  | 'OnboardingMediaRouter'
export type PinProductPathListsType =
  | '/dashboard/pin-product'
  | '/dashboard/infinite-scroll-tab'
  | '/dashboard/onboarding-media'
type RouterInstanceType = RouterFeatureInterface<PinProductNamedRoutesType, PinProductPathListsType>

export const HomepageSlottingRouter: RouterFeatureInterface<
  'HomepageSlottingRouter',
  '/dashboard/homepage-slotting'
> = {
  name: 'HomepageSlottingRouter',
  Component: HomepageSlotting,
  path: '/dashboard/homepage-slotting',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: HomepageSlottingRBAC.pageID,
}

export const DynamicChannelRouter: RouterFeatureInterface<
  'DynamicChannelRouterRouter',
  '/dashboard/dynamic-channel'
> = {
  name: 'DynamicChannelRouterRouter',
  Component: DynamicChannel,
  path: '/dashboard/dynamic-channel',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: DynamicChannelRBAC.pageID,
  isDashboard: true,
}

export const PinProductRouter: RouterInstanceType = {
  name: 'PinProductRouter',
  Component: PinProductPage,
  path: '/dashboard/pin-product',
  routeType: 'PRIVATE',
  rbacPageID: PINProductRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

export const InfiniteScrollRouter: RouterInstanceType = {
  name: 'InfiniteScrollTabRouter',
  Component: InfiniteScrollTabPage,
  path: '/dashboard/infinite-scroll-tab',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: infiniteScrollTabbingRolesRBAC.pageID,
  isDashboard: true,
}
export const OnboardingMediaRouter: RouterInstanceType = {
  name: 'OnboardingMediaRouter',
  Component: OnboardingMediaPage,
  path: '/dashboard/onboarding-media',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: OnboardingMediaRBAC.pageID,
  isDashboard: true,
}

const CategoryAndPositionRouter = [
  HomepageSlottingRouter,
  DynamicChannelRouter,
  PinProductRouter,
  InfiniteScrollRouter,
  OnboardingMediaRouter,
]

export const CategoryAndPositionRouterDetail = generateRouterDetail(CategoryAndPositionRouter)

export default CategoryAndPositionRouter
